import { useEffect, useRef } from "react";
import rootElement from "../rootElement";

export function useRootElementEvents<
  EventName extends keyof HTMLElementEventMap
>(
  events: EventName[],
  callback: (e: HTMLElementEventMap[EventName]) => void,
) {
  const ref = useRef(callback);
  ref.current = callback; // Always point to the most recent callback
  useEffect(() => {
      const handler = (e: Event) => ref.current(e as HTMLElementEventMap[EventName]);
      events.forEach((event) => rootElement.addEventListener(event, handler));
      return () => events.forEach((event) => rootElement.removeEventListener(event, handler));
  }, [events, ref]);
};
